// Chrome Translate moves React-owned text nodes into <font>, so skip DOM ops on nodes it moved.
// See https://github.com/facebook/react/issues/11538
const { removeChild, insertBefore } = Node.prototype;

Node.prototype.removeChild = function guardedRemoveChild<T extends Node>(this: Node, child: T): T {
  if (child.parentNode !== this) return child;
  return removeChild.call(this, child) as T;
};

Node.prototype.insertBefore = function guardedInsertBefore<T extends Node>(
  this: Node,
  node: T,
  ref: Node | null
): T {
  if (ref && ref.parentNode !== this) return node;
  return insertBefore.call(this, node, ref) as T;
};

export {};
